var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.22,
    height: 91.208,
    viewBox: "0 0 91.22 91.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#80e6eb;}.b{fill:#4abad0;}.c{fill:#2494bd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.976 10.992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.976 -10.992)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M190.51,132.741l7.814,8.9a45.427,45.427,0,0,0,10.995-29.7,46.045,46.045,0,0,0-.266-4.938c-2.74,1.373-6.727,3.308-11.428,5.561A33.763,33.763,0,0,1,190.51,132.741Z",
    transform: "translate(-118.099 -66.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143.242,186.387l-1.642,12.4A45.56,45.56,0,0,0,168,183.621l-7.814-8.9a33.991,33.991,0,0,1-16.946,11.667Z",
    transform: "translate(-87.777 -108.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M45.591,115.24A33.919,33.919,0,0,1,19.238,59.966L6.625,57.61A45.632,45.632,0,0,0,53.8,126.188l1.638-12.4a33.847,33.847,0,0,1-9.851,1.456Z",
    transform: "translate(0.024 -35.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M101.788,40.669q-.167-1.547-.433-3.04a45.674,45.674,0,0,0-25.3-33.193q-1.874-.9-3.838-1.619A45.636,45.636,0,0,0,17.49,21.91L30.1,24.267A33.9,33.9,0,0,1,90.367,45.61v.627C95.061,43.983,99.048,42.049,101.788,40.669Z",
    transform: "translate(-10.834 -0.008)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.90ececa2d4943d54c7343ed8dbe3e198.svg";
export { ForwardRef as ReactComponent };